export default [{
  mainButton: {
    name: 'staffFilters',
    label: 'Search',
    goTo: '?modal=inputFilterModal~staff',
    tooltip: 'Search staff'
  }
}, {
  mainButton: {
    name: 'uploadDownload',
    label: 'Upload<br>Download',
    tooltip: 'Uploading and downloading data',
    menu: [{
      name: 'download',
      label: 'Download employee attendance records',
      goTo: '?modal=download-attendanceRecords',
      metrikaIdReach: 'btn_download_attendance_records'
    }, {
      name: 'downloadReport',
      label: 'Download overhaul / flaw report',
      goTo: '?modal=download-attendanceRecords',
      metrikaIdReach: 'btn_download_report_rework_flaw'
    }]
  }
}];